export class ClassList {
  public static of(...classes: (string | undefined)[]): ClassList {
    return new ClassList(classes);
  }

  private _classes: string[];

  private constructor(classes: (string | undefined)[]) {
    this._classes = classes.filter((className) => className !== undefined) as string[];
  }

  public has(className: string) {
    return this._classes.includes(className);
  }

  public add(className: string | undefined, expr?: boolean): ClassList {
    if (className !== undefined && (expr === undefined || expr === true)) {
      this._classes.push(className);
    }

    return this;
  }

  public merge(other: ClassList): ClassList {
    const lookup = new Set<string>();
    const nextList: string[] = [];

    this._classes.forEach((className) => {
      if (!lookup.has(className)) {
        lookup.add(className);
        nextList.push(className);
      }
    });

    other._classes.forEach((className) => {
      if (!lookup.has(className)) {
        lookup.add(className);
        nextList.push(className);
      }
    });

    return new ClassList(nextList);
  }

  public remove(className: string | undefined): ClassList {
    if (className === undefined) {
      return this;
    }

    const indexOf = this._classes.indexOf(className);

    if (indexOf >= 0) {
      this._classes.splice(indexOf, 1);
    }

    return this;
  }

  get names(): string {
    return this._classes.join(' ');
  }

  public toString(): string {
    return this._classes.join(' ');
  }
}
